export default class AudioTagPlayer implements IPlayer {

    play(audioSource: string): void {
        if (audioSource) {
            this.el.src = audioSource;
            this.el.currentTime = 0;
        }
        this.el.play();
    }
    stop(): void {
        this.el.currentTime = 0;
        this.el.pause();
    }
    pause(): void {
        this.el.pause();
    }
    private static instance: AudioTagPlayer;
    private el: HTMLAudioElement;
    private constructor() {
        this.el = document.createElement('audio');
        this.el.style.display = 'none';
        document.body.appendChild(this.el);
    }

    static getInstance() {
        if (!AudioTagPlayer.instance) {
            AudioTagPlayer.instance = new AudioTagPlayer();
        }
        return AudioTagPlayer.instance;
    }
}


// WEBPACK FOOTER //
// ./src/components/Player/AudioTagPlayer.ts